<template>
  <div class="wrapper">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="bg-image" v-if="!loading" :style="cssProps"></div>
    <div class="footer" v-if="!loading">
      <div class="rating">
        <p>{{ this.$store.getters.TRANSLATIONS["rate_your_expirience"] }}</p>

        <div class="star-rating">
          <star-rating
            @rating-selected="setRating"
            v-model="rating"
            :show-rating="false"
            :padding="15"
            :inline="true"
            :star-size="30"
            :animate="true"
          ></star-rating>
          <textarea
            class="details"
            v-model="details"
            v-if="showDetails"
            :placeholder="this.$store.getters.TRANSLATIONS['type_your_comment']"
          ></textarea>
          <button class="button button-continue" v-on:click="doContinue()">
            {{ this.$store.getters.TRANSLATIONS["continue"] }}
          </button>
        </div>
      </div>
    </div>

    <v-dialog style="margin-top: 25%" :width="350" />
  </div>
</template>

<script>
import StarRating from "vue-star-rating";
export default {
  created() {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("login");
      return;
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    let requestedVehicleInfo = this.$storage.get("requestedVehicleInfo");
    if (!requestedVehicleInfo) {
      this.$router.push("/hello");
    } else {
      this.$http
        .get(
          `${process.env.SERVER_URL}/B9F779B25F024CDE94DDE93DD044918B/${requestedVehicleInfo.onDemandId}`,
          {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          }
        )
        .then((response) => {
          if (response.data) {
            this.ticketBarcode = response.data.ticketBarcode;
          } else {
            console.log("Can't get onDemand by id");
            this.$router.push("/hello");
          }
        })
        .then(() => {
          console.log(this.ticketBarcode);
          return this.$http
            .get(
              `${process.env.SERVER_URL}/5E4AAF52D74D4575B36B00EA57AD9C39/${this.ticketBarcode}`,
              {
                headers: {
                  "x-access-token": this.$storage.get("parkendaToken")
                }
              }
            )
            .then((response) => {
              if (response.status != 204) {
                if (this.$route.query.returnTo) {
                  this.$router.push(`/${this.$route.query.returnTo}`);
                } else {
                  this.$router.push("/hello");
                }
              }
            });
        })
        .catch((error) => {
          let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "OK",
                handler: () => {
                  if (this.$route.query.returnTo) {
                    this.$router.push(`/${this.$route.query.returnTo}`);
                  } else {
                    this.$router.push("/hello");
                  }
                }
              }
            ]
          });
        })
        .finally(() => {
          clearTimeout(timeout);
          this.loading = false;
        });
    }
  },
  data() {
    return {
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/appRatingBackground.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      loading: true,
      rating: 5,
      isRedirected: false,
      ticketBarcode: "",
      showDetails: false,
      details: "",
      setRating: () => {
        this.showDetails = this.rating < 4;
      },
      doContinue: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/2210F70E1B5E46BE92FF99BB9273C679`,
            {
              value: this.rating,
              type: "PARKENDA",
              ticketBarcode: this.ticketBarcode,
              customerId: this.$store.getters.USER.id,
              details: this.details
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("AppRating response");
            console.log(response);
            this.isRedirected = true;
            if (this.$route.query.returnTo) {
              this.$router.push(`/${this.$route.query.returnTo}`);
            } else {
              this.$router.push("/hello");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK"
                }
              ]
            });
          })
          .finally(() => {
            console.log("HERE");
            clearTimeout(timeout);
            this.loading = false;
            if (!this.isRedirected) {
              if (this.$route.query.returnTo) {
                this.$router.push(`/${this.$route.query.returnTo}`);
              } else {
                this.$router.push("/hello");
              }
            }
          });
      }
    };
  },
  components: {
    StarRating
  }
};
</script>

<style scoped src="../styles/main.css"></style>
<style scoped>
.bg-image {
  height: 70vh;
}
.footer {
  height: 30vh;
}
.rating {
  height: 42%;
}
.rating p {
  text-align: center;
  color: #fbae31;
  font-size: 5.5vw;
  margin-top: 4vh;
  font-family: BrandonGrotesqueMedium;
}
.star-rating {
  margin-top: 17px;
  display: flex;
  flex-direction: column;
}
.vue-star-rating {
  margin: 0 auto;
}
.button-continue {
  background-color: white;
  color: #fbae31;
  border: 1px solid #fbae31;
}
.details {
  margin: 10px 15vw 0 15vw;
  padding: 10px;
  border: none;
  background: #f3f2f2;
  resize: none;
}
</style>



// WEBPACK FOOTER //
// src/components/AppRating.vue